//Models
PJQ.models.bidForms.Settings = PJQ.models.BaseModel.extend({
	idAttribute: 'settingId',
	endpoint: function () {
		if (this.get('projectId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'bidForms'
				},
				{
					endpoint: 'settings'
				}
			]);
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidForms'
			},
			{
				endpoint: 'settings'
			}
		]);
	},
	parse: function (model) {
		if (model) {
			if (model.additionalBidDocuments) {
				this.additionalBidDocuments = new PJQ.collections.files.Files(model.additionalBidDocuments);
			}
			else {
				this.additionalBidDocuments = new PJQ.collections.files.Files();
			}
		}
		else {
			this.additionalBidDocuments = new PJQ.collections.files.Files();
		}
		return model;
	},
	beforeSave: function () {
		this.set('additionalBidDocuments', this.additionalBidDocuments.getChangedModels());
	},
	isSealedBidContact: function(id) {
		return _.size(_.filter(this.get('sealedBidContactList'), function(contact) {
			return contact.id == id;
		})) > 0;
	},
	sealBidForms: function(callback) {
		if(_.size(this.get('sealedBidContactList')) === 0){
			return false;
		}

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'bidForms'
				},
				{
					endpoint: 'seal'
				}]),
			data: this
		}).post().done(_.bind(function (res) {
			this.set(res);

			if(typeof callback === 'function') {
				callback(true);
			}
		}, this)).fail(_.bind(function (error) {
			if(typeof callback === 'function') {
				callback(false);
			}
		}, this));
	},
	unsealBidForms: function(unsealAll = false, callback) {
		this.set('isSealBids', false);
		this.set('unsealAll', unsealAll);

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'bidForms'
				},
				{
					endpoint: 'unseal'
				}]),
			data: this
		}).post().done(_.bind(function (res) {
			this.set(res);

			if(typeof callback === 'function') {
				callback(true);
			}
		}, this)).fail(_.bind(function (error) {
			if(typeof callback === 'function') {
				callback(false);
			}
		}, this));
	}
});